import styled from 'styled-components';

import zIndexLayers from '../../../../services/ZIndexLayers/ZIndexLayers';
import { ThemeProp } from '../../../../theme/Themes';

export const drawerEasingFunction = 'cubic-bezier(0.4, 0, 0.6, 1)';
export const drawerTransitionWithoutUnits = 300;
export const drawerTransitionDuration = `${drawerTransitionWithoutUnits}ms`;

export const MIN_WIDTH_EXPANDABLE = '968px';

type ContentContainerProps = WithDrawerConstraints & WithOpenState;
export const ContentContainer = styled.div<ContentContainerProps>`
  flex: 2;
  height: 100%;

  margin-left: ${({ $expandedWidth, $collapsedWidth, $isOpen }: ContentContainerProps) =>
    $isOpen ? $expandedWidth : $collapsedWidth};

  transition: all 0.2s ease-in;

  max-width: ${({ $collapsedWidth, $expandedWidth, $isOpen }: ContentContainerProps) =>
    `calc(100% - ${$isOpen ? $expandedWidth : $collapsedWidth})`};

  @media (max-width: ${MIN_WIDTH_EXPANDABLE}) {
    max-width: ${({ $collapsedWidth }: ContentContainerProps) => `calc(100% - ${$collapsedWidth})`};
    margin-left: ${({ $collapsedWidth }: ContentContainerProps) => $collapsedWidth};
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    margin-left: 0;
    max-width: 100%;
  }
`;

const defaultExpandedDrawerWidth = 'unset';

export interface WithOpenState {
  $isOpen: boolean;
}

interface WithDrawerConstraints {
  $expandedWidth?: string;
  $collapsedWidth?: string;
}

type DrawerContainerProps = WithOpenState & WithDrawerConstraints;
export const DrawerContainer = styled.div<DrawerContainerProps>`
  position: fixed;
  max-width: ${({ $expandedWidth }: DrawerContainerProps) => $expandedWidth ?? defaultExpandedDrawerWidth};
  top: 0;
  bottom: 0;
  z-index: ${zIndexLayers.drawer};
  @media (max-width: ${MIN_WIDTH_EXPANDABLE}) {
    max-width: ${({ $collapsedWidth }: ContentContainerProps) => $collapsedWidth};
  }
`;

export const DrawerLayoutContainer = styled.div`
  height: 100vh;
  display: flex;
`;
